import React from "react";
import CodeExample from "../../partials/content/CodeExample";
import { TextField,MenuItem,InputLabel,Select,IconButton,Button } from '@material-ui/core';
import { getUsers,updateUser,updateMaster,getScreenFields,getMaster,deleteUser } from "../../crud/auth.crud";

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import Pagination from "react-js-pagination";

//import PaginationInfo from "../../partials/content/PaginationInfo";

import "../../customCss/SuperResponsiveTableStyle.css";
import "../../customCss/Pagination.css";

import EditIcon from '@material-ui/icons/Edit';

import Autocomplete from '@material-ui/lab/Autocomplete';

import HighlightOffIcon from '@material-ui/icons/HighlightOff';
 import { Link } from "react-router-dom";

 import { Bounce } from 'react-activity';
import 'react-activity/dist/react-activity.css';



import ToggleOnOutlinedIcon from '@material-ui/icons/ToggleOnOutlined';
import ToggleOffOutlinedIcon from '@material-ui/icons/ToggleOffOutlined';
import { Alert } from '@material-ui/lab'; 


import Grid from "../../partials/content/Grid";


import CircularProgress from '@material-ui/core/CircularProgress';


import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Icon from '@material-ui/core/Icon';

import { Tooltip } from "@material-ui/core";






export default class User extends React.Component {
  state = {
    users:[],
    toCount :0,
    activePage:1,
    pageSize:5,
    totalCount:0,
    updateStatus:false,
    statusColor:'',
    statusMessage:'',
    filterFields :{},
    fields:[],
    filter:false,
    sortField :'',
    sortDir:'asc',
    open:false,
    currentUser:"",
	postObj:{},
	filter:false,
	isReset:false,
	isLoading:false,
  }
  GlobalHeader = "User";
 
  handleDeleteDialog = (userId) => {
    this.setState({open:true,currentUser:userId});
    
    //alert(userId);

  };

  handleClose = () => {
    this.setState({open:false})
  };



constructor(props)
{
	super(props);
	this.handleSort = this.handleSort.bind(this);
}
  handlePageSizeChange(option) {
  	let currentPage = 1;
  	 	
  	 	if(this.state.toCount<option.target.value) 
  	 		currentPage = 1;
		else if(parseInt(this.state.toCount/option.target.value)==(this.state.toCount/option.target.value))
			currentPage = 	parseInt(this.state.toCount/option.target.value)
		else
			currentPage=parseInt(this.state.toCount/option.target.value)+1;

			this.setState({activePage: currentPage,pageSize: option.target.value},
				 () => {
					getUsers(this.state.activePage,this.state.pageSize,this.state.sortField,this.state.sortDir,this.state.postObj)///.then(response => response.data)
				    .then((response) => {
				        this.setState({ users: response.data });
				 		this.setState({totalCount:response.headers["x-total-records"]});
				        this.setState((state)=>({toCount : state.activePage*state.pageSize<=state.totalCount?state.activePage*state.pageSize:state.totalCount}));
				     })
				}
				)
  }

  handlePageChange(pageNumber) {
    
     getUsers(pageNumber,this.state.pageSize,this.state.sortField,this.state.sortDir,this.state.postObj)//.then(response => response.data)
    .then((response) => {
    	
        this.setState({ users: response.data });
 		this.setState({activePage: pageNumber})	
 		this.setState({totalCount:response.headers["x-total-records"]});
        this.setState((state)=>({toCount : state.activePage*state.pageSize<=state.totalCount?state.activePage*state.pageSize:state.totalCount}));
     })
  }
  handleActive(userId,userStatus)
  {
  		this.setState({users: this.state.users.map(el => (el.userId === userId ? {...el, isActive :!userStatus}: el))});	

  		let data ={'isActive':!userStatus};
  		updateMaster('user',userId,data)
  		.then((response) => {
  			 this.setState({updateStatus:true,statusMessage:'User Updated Successfully',statusColor:'alert-success'});
				setTimeout(() => {this.setState({updateStatus:false})}, 3000);

  		})
  		
  }
    handleDelete()
  {
  		//this.setState({users: this.state.users.map(el => (el.userId === userId ? {...el, isActive :!userStatus}: el))});	
  		let userId=this.state.currentUser;
  		//console.log('User ID :::',userId);
  		this.setState({open:false})
  		//alert(userId);

  		let data ={'isDeleted':true};
  		/*updateMaster('user',userId,data)
  		.then((response) => {
  			
  			this.setState({updateStatus:true,statusMessage:'User Deleted Successfully',statusColor:'alert-success'});
  			getUsers(this.state.activePage,this.state.pageSize,this.state.sortField,this.state.sortDir)//.then(response => response.data)
			    .then((response) => {
			 		this.setState({totalCount:response.headers["x-total-records"]});
			        this.setState((state)=>({toCount : state.activePage*state.pageSize<=state.totalCount?state.activePage*state.pageSize:state.totalCount}));
			        this.setState({ users: response.data });
			     });
  			setTimeout(() => {this.setState({updateStatus:false})}, 3000);
  
  		})*/

		deleteUser(userId,data)
  		.then((response) => {
  			
  			this.setState({updateStatus:true,statusMessage:'User Deleted Successfully',statusColor:'alert-success'});
  			getUsers(this.state.activePage,this.state.pageSize,this.state.sortField,this.state.sortDir,this.state.postObj)//.then(response => response.data)
			    .then((response) => {
			 		this.setState({totalCount:response.headers["x-total-records"]});
			        this.setState((state)=>({toCount : state.activePage*state.pageSize<=state.totalCount?state.activePage*state.pageSize:state.totalCount}));
			        this.setState({ users: response.data });
			     });
  			setTimeout(() => {this.setState({updateStatus:false})}, 3000);
  
  		})
  		
  }

  handleSort(fieldName)
  {
  	        this.setState((state)=>({sortField:fieldName,sortDir:state.sortDir=='asc'?'desc':'asc'}));
  	        //alert(fieldName+ "  "+this.state.sortDir);

  	        getUsers(this.state.activePage,this.state.pageSize,fieldName,this.state.sortDir,this.state.postObj)//.then(response => response.data)
			    .then((response) => {
			 		this.setState({totalCount:response.headers["x-total-records"]});
			        this.setState((state)=>({toCount : state.activePage*state.pageSize<=state.totalCount?state.activePage*state.pageSize:state.totalCount}));
			        this.setState({ users: response.data });
			     });
  }
  handleFilter(event)
  {
  	let postObj={};
  	//console.log(this.state.fields.fields);

  	this.state.fields[0].fields.map((field)=> {
  			
  			if(this.state[`Filter_${field.fieldName}`]!=undefined && this.state[`Filter_${field.fieldName}`]!='')
  			{
				if(field.dataType==="String" && field.fieldName==='firstName')
					postObj['search'+field.fieldName]=this.state[`Filter_${field.fieldName}`];
  				else if(field.dataType==="lookup")
  				 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
  				 else
  				 	postObj[field.fieldName]=this.state[`Filter_${field.fieldName}`];
  			}

  			})
  			this.setState({activePage:1})
  		   getUsers(1,this.state.pageSize,this.state.sortField,this.state.sortDir,postObj)//.then(response => response.data)
			    .then((response) => {
			 		this.setState({totalCount:response.headers["x-total-records"],postObj:postObj});
			        this.setState((state)=>({toCount : state.activePage*state.pageSize<=state.totalCount?state.activePage*state.pageSize:state.totalCount}));
			        this.setState({ users: response.data });
			     });	
  }
  handleReset(event)
  {
	console.log("rest");
	let postObj={};
	//this.state.filter=false;
	this.setState({isReset:true});
						//this.setState({filter:false},function(){
			  //this.setState({filter:true})		
			  //})
	 this.state.fields[0].fields.map((field)=> {
		
		if(field.dataType!=='lookup')
		{
			this.setState({[`Filter_${field.fieldName}`]:''});
		}
		if(field.dataType==='lookup')
		{
			//this.setState({[field.fieldName]:[]});
			this.setState({[`Filter_${field.fieldName}`]:''});
		}

		})

  			this.setState({activePage:1})
  		   getUsers(1,this.state.pageSize,this.state.sortField,this.state.sortDir,postObj)//.then(response => response.data)
			    .then((response) => {
			 		this.setState({totalCount:response.headers["x-total-records"],isReset:false});
			        this.setState((state)=>({toCount : state.activePage*state.pageSize<=state.totalCount?state.activePage*state.pageSize:state.totalCount}));
			        this.setState({ users: response.data });
	     });	
  }
  async componentDidMount()
  {

  	await getScreenFields('user')
  	.then((fieldResponse) => {


  		
  		

  		fieldResponse.data[0].fields
  			.filter((fieldFilter) => fieldFilter.dataType==='lookup')
  			.map((fieldMap)=>
  					{
  							getMaster(fieldMap.lookUp.lookupName)
							.then((filterResponse)=>
								{
									this.setState({[fieldMap.fieldName]:filterResponse.data});

								})
						}
  					
  				)


				  this.setState({fields:fieldResponse.data,filter:true});

				  console.log("fieldResponse",fieldResponse.data)
    });
			
	getUsers(this.state.activePage,this.state.pageSize,this.state.sortField,this.state.sortDir)//.then(response => response.data)
	    .then((response) => {
	 		this.setState({totalCount:response.headers["x-total-records"]});
	        this.setState((state)=>({toCount : state.activePage*state.pageSize<=state.totalCount?state.activePage*state.pageSize:state.totalCount}));
	        this.setState({ users: response.data });
	     });

  }
  autocompleteOnChange=(event,newValue,fieldName,lookupKey) => {
	if(event!==null && newValue!==null)
	{
	  console.log("autocomplete change:::",event ,newValue,fieldName,lookupKey,newValue[lookupKey]);
	  this.setState({[fieldName]:newValue[lookupKey]});
	}
	
  }

  autocompleteOnInputChange=async (event,value,fieldName,lookupKey,lookupName) =>  {
	if(event!==null && value!==null && value.length>3)
	{
	//  console.log("autocomplete input change:::",event ,fieldName,lookupKey);
	  //console.log("autocomplete input change:::",event ,value,fieldName,lookupKey);
	  //this.setState({[fieldName]:newValue[lookupKey]});
	  //var postObj = {
      //  nameLowerCase: value.toLowerCase()
        
      //};
      //let accountData=[];

	 // this.state[fieldName].filter(x=>x.accountName.toLowerCase().includes(value.toLowerCase())).map((p) => {
	  
	//	accountData.push(p)

	 // });
    
    	
              //this.setState({ [fieldName]:accountData});
       /*await getMaster(lookupName)
		.then((filterResponse)=>
		{
			this.setState({[fieldName]:filterResponse.data});
		});*/
	}
	
  }
  
 

  render() {
	//console.log(this.state.fields);
    return (
      <>
    <div>
	
		
        <div className="row">
          <div className="col-md-12">
            <Grid beforeCodeTitle="User" jsCode="true" createPath="/createUser">
              <div className="kt-section">

               {this.state.updateStatus && (
						<Alert severity="success">{this.state.statusMessage}</Alert>
				  )}
			{
      	 
<div className="container">
<div className="row">

	
	  {
		this.state.fields.map((screen) => (
			screen.fields.map((field)=>{
			  
				  if(field.dataType==='String')
				  
				  return(
					  	<div className="col-lg-6">
						   <TextField fullWidth name={field.fieldName} label={field.displayName}
						     value={this.state[`Filter_${field.fieldName}`]}
									 onChange={e=>this.setState({[`Filter_${field.fieldName}`]:e.target.value})}
									 />
						</div>
					  
				  )
				  
								
				 
				  else if(field.dataType==='lookup')
					  return(
						<div className="col-lg-6">
							   <Autocomplete
								  id={field.lookUp.lookupKey}
								  name={field.lookUp.lookupKey}
								  value={this.state[`Filter_${field.fieldName}`]}
								  options={this.state[field.fieldName]}
								  autoComplete={true}
								  clearOnBlur={true}
								  getOptionLabel={(option) => option[field.lookUp.lookupDisplay]}
								  onChange={(event,newValue)=>{this.autocompleteOnChange(event,newValue,`Filter_${field.fieldName}`,field.lookUp.lookupId);}}
								  onInputChange={(event,value)=>{this.autocompleteOnInputChange(event,value,field.fieldName,field.lookUp.lookupId,field.lookUp.lookupName);}}						
								  renderInput={(params) => <TextField {...params} label={field.displayName}  />}
							  />
							  </div>
						   
				  )
				 
				 
			  
			  }) //{/* map  inner loop close*/}
		  )) //{/* map loop close*/}
  }

</div>
  <div className="row">
	  
	  
	  <Button
	  variant="outlined"
	  color="primary"
	  onClick={this.handleFilter.bind(this)}
	  endIcon={<Icon>search</Icon>}
	  style={{'padding':'10px','margin':'10px'}}
	  >
	  {
		  this.state.isLoading==true&&<><Bounce /></>
	  }
	  {
		  this.state.isLoading==false&&<>Apply Filter</>
	  }</Button>
	  
	  <Button
	  variant="outlined"
	  color="primary"
	  onClick={this.handleReset.bind(this)}
	  endIcon={<Icon>backspace</Icon>}
	  style={{'padding':'10px','margin':'10px'}}
	  >
	  {
		  this.state.isReset==true&&<><Bounce /></>
	  }
	  {
		  this.state.isReset==false&&<>Reset Filter</>
	  }
	  </Button>
	 

 </div>
	</div>

  }



      	<div className="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded" id="kt_apps_user_list_datatable">
      	   <div className="footer">
			   <div className="paginationInfo">
			   		<span>
			   			Displaying {((this.state.activePage-1)*this.state.pageSize)+1} to {this.state.toCount} of {this.state.totalCount}
					</span>
			   </div>
			   <div class="paginationSize">
			   		<div>Page Size&nbsp;</div> 
						<Select id="select" onChange={this.handlePageSizeChange.bind(this)} value={this.state.pageSize}>
						<MenuItem value="5">5</MenuItem>	
						<MenuItem value="10">10</MenuItem>
						<MenuItem value="25">25</MenuItem>
						<MenuItem value="50">50</MenuItem>
						</Select>
			   </div>
			   <div className="paginationContainer">
				    <Pagination
						activePage={this.state.activePage}
						itemsCountPerPage={this.state.pageSize}
						totalItemsCount={this.state.totalCount}
						pageRangeDisplayed={5}
						prevPageText="<"
						nextPageText=">"
						onChange={this.handlePageChange.bind(this)}
					/>
				</div>
			</div>
			
		   <Table >
		    <Thead >
		    <Tr >
		    {
		    	this.state.fields.map((screen) => (
		    		screen.fields.map((field)=>{
					if(field.displayName!='Action')
						return(<Th onClick={this.handleSort.bind(this,field.fieldName)}>
						
						<span className='headerSpan' style={{cursor:'pointer'}}>
							{field.displayName}&nbsp;
							{
								field.fieldName===this.state.sortField && this.state.sortDir==='desc' &&
							<i className="flaticon2-arrow-up"></i>
							}
							{
								field.fieldName===this.state.sortField && this.state.sortDir==='asc'&& 
							<i className="flaticon2-arrow-down"></i>
							}
							</span>
							</Th>)
							
							if(field.displayName==='Action')
								return(
								<Th>
								<span>{field.displayName}&nbsp;
								{/*  <Tooltip
          						title= {this.state.filter?"Hide Filter":"Show Filter"}
          							>
								<IconButton onClick={()=>{this.setState({filter:!this.state.filter})}}>
									<VerticalSplitIcon style={{ color: '#fff',fontSize: 20}}/>
								</IconButton>
								</Tooltip>*/}
								</span>
								</Th>)
		    			})
		    		))
		    }
		    </Tr>
		   
		       
		    </Thead>
		    <Tbody>
		  { this.state.isLoading &&
			<div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>                            
										<Alert icon={<CircularProgress size={15} />}>&nbsp;&nbsp;Progressing.Please wait.</Alert>      
									  </div>}
					{
						this.state.users.map((user)=>(
						<Tr>{
						this.state.fields.map((screen) => (
						screen.fields.map((field)=>{
						 		

						 	 if(field.fieldName==='firstName')
						 		return(
										<Td data-field="AgentName" >
											<Tooltip
          										title={user.firstName +' '+ user.lastName}>		
							               <span >
							                  <div className="kt-user-card-v2">
							                     <div className="kt-user-card-v2__pic" >
							                        <div className="kt-badge kt-badge--xl kt-badge--info" style={{ 'background-color': user.colorCode}}>{(user.firstName).substring(0,1).toUpperCase()}{(user.lastName).substring(0,1).toUpperCase()}</div>
												</div>
							                     
							                  </div>
											  {(user.firstName + ' '+user.lastName)}
							               </span>
										   </Tooltip>
										  
							            </Td>
						 			   )
						 	else if(field.displayName==='Action')
						 		return(
										<Td >
										

										<IconButton onClick={(e) => this.handleActive(user.userId,user.isActive)}>
										{user.isActive==true &&
											 <Tooltip
          										title= "Dectivate user"
          										>
										<ToggleOnOutlinedIcon style={{ color: '#228B22',fontSize: 30 }}/>
											</Tooltip>
										}
										{user.isActive==false &&
											 <Tooltip
          								title= "Activate user"
          							>
										<ToggleOffOutlinedIcon style={{ color: '#DC143C',fontSize: 30  }}/>
										</Tooltip>
										}
										</IconButton>

										 <Tooltip
          								title= "Delete user"
          								>
										<IconButton onClick={(e) => this.handleDeleteDialog(user.userId)}>
										<HighlightOffIcon style={{ color: '#5578eb',fontSize: 25}}/>   
										</IconButton>
										</Tooltip>

										<Link  to={{pathname:"/edituser", data: {user:user}}}>
										 <Tooltip
          										title="Edit user" 

          									>
											<IconButton>
												<EditIcon style={{ color: '#5578eb',fontSize: 25}}/>   
											</IconButton>
											</Tooltip>
										</Link>

										<Link  to={{pathname:"/editps", data: {user:user}}}>
										 <Tooltip
          										title="Set Password" 

          									>
											<IconButton>
												<EditIcon style={{ color: '#5578eb',fontSize: 25}}/>   
											</IconButton>
											</Tooltip>
										</Link>

										</Td>
						 			)
						 	else if(field.fieldName!='firstName')
						 		return(<Td>{user[field.fieldName]}</Td>)
						 	 

							})
						))
						}
						</Tr>
						))
					}
		    </Tbody>
		     
		</Table>
		
		<div className="footer">
			   <div className="paginationInfo">
			   		<span>
			   			Displaying {((this.state.activePage-1)*this.state.pageSize)+1} to {this.state.toCount} of {this.state.totalCount}
					</span>
			   </div>
			   <div class="paginationSize">
			   		<div>Page Size&nbsp;</div> 
						<Select id="select" onChange={this.handlePageSizeChange.bind(this)} value={this.state.pageSize}>
						<MenuItem value="5">5</MenuItem>	
						<MenuItem value="10">10</MenuItem>
						<MenuItem value="25">25</MenuItem>
						<MenuItem value="50">50</MenuItem>
						</Select>
			   </div>
			   <div className="paginationContainer">
				    <Pagination
						activePage={this.state.activePage}
						itemsCountPerPage={this.state.pageSize}
						totalItemsCount={this.state.totalCount}
						pageRangeDisplayed={5}
						prevPageText="<"
						nextPageText=">"
						onChange={this.handlePageChange.bind(this)}
					/>
				</div>
			</div>
		</div>

		</div>
		</Grid>
		</div>
		</div>
		
		</div>

 		<Dialog
        open={this.state.open}
        onClose={this.handleClose.bind(this)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Delete User?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
           Are you sure, You want to delete User
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleClose.bind(this)} color="primary">
            No
          </Button>
          <Button onClick={this.handleDelete.bind(this)} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
       
      </>
    );
  }
}
